import { gridOptions } from "../../utils/globalOptions";

const totalPeopleConfig = (dataArray) => {

  const sharedOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: false,
    },
  };

  const colors = [
    {
      backgroundColor: "#97D576",
      borderColor: "#58A82E",
      pointBackgroundColor: "#58A82E",
      pointBorderColor: "#58A82E",
      hoverBackgroundColor: "#2F8401",
    },
  ];
  
  const labels = [
    "San José",
    "Alajuela",
    "Cartago",
    "Heredia",
    "Guanacaste",
    "Puntarenas",
    "Limón",
  ];
  
  const datasets = [
    {
      barThickness: 26,
      maxBarThickness: 56,
      minBarLength: 2,
  
      label: "Total de Personas Evacuadas",
      ...colors[0],
      borderWidth: 1,
      data: dataArray,
    },
  ];
  
  const data = {
    labels,
    datasets,
  };
  
   return {
    type: "horizontalbar",
    title: "Total de personas evacuadas",
    subtitle: "Distribuidas por provincia",
    data,
    options: {
      ...sharedOptions,
      ...gridOptions,
      plugins: {
        // Change options for ALL labels of THIS CHART
        datalabels: {
          color: "#ffffff",
          anchor: "start",
          align: "end",
          offset: 1,
          clamp: true,
          labels: {
            title: {
              font: {
                weight: "bold",
              },
            },
          },
        },
      },
    },
  };
  

}


export default totalPeopleConfig;
